import { SUBDOMAIN_ENUM } from '../../../../../../constants/subddomainEnum';

export const hideComponentCheck = (subdomainValue: SUBDOMAIN_ENUM): boolean => {
  return [SUBDOMAIN_ENUM.MARTINBUCER].includes(subdomainValue);
};
